/**
 * /dashboard/performance — Performance hub, "My goals" view
 * (Phase 3d — 2026-06-01).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/page.tsx flattened
 * with the old `layout.tsx` into one route that uses
 * PerformanceModuleShell.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { GoalsTab } from "@/components/performance/goals-tab";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/performance/")({
  component: PerformanceHubRoute,
});

function PerformanceHubRoute() {
  return (
    <PerformanceModuleShell
      title="Goals"
      description="Goals, 1:1s, feedback and reviews in one place."
    >
      <PerformanceFeatureGate>
        <GoalsTab />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
